import { render, staticRenderFns } from "./ChargeRecords.vue?vue&type=template&id=c4bdc86a&scoped=true&"
import script from "./ChargeRecords.vue?vue&type=script&lang=js&"
export * from "./ChargeRecords.vue?vue&type=script&lang=js&"
import style0 from "./ChargeRecords.vue?vue&type=style&index=0&id=c4bdc86a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4bdc86a",
  null
  
)

export default component.exports